import { render, staticRenderFns } from "./DialogEditHonor.vue?vue&type=template&id=57653976&scoped=true"
import script from "./DialogEditHonor.vue?vue&type=script&lang=js"
export * from "./DialogEditHonor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57653976",
  null
  
)

export default component.exports